define('views/blocks/ProductSidedishDefaultView',['underscore', 'jquery', 'backbone', 'app','views/blocks/ProductSidedishView'],
function(_,jQuery,BackBone,app,ProductSidedishView){
        return ProductSidedishView.extend({
            events:{
                'change input': 'changeQuantity',
                'click .sidedish__el__qty': 'clickQuantifier',
                'click .sidedish__el__label': 'clickQuantifier',
            },
            initialize:function(options){
                ProductSidedishView.prototype.initialize.call(this,options);
                this.render();
            },
            changeQuantity: function (e) {
                var view = this,
                    currentTarget = e.currentTarget,
                    currentInput = $(currentTarget),
                    id_product = currentInput.data('id_product'),
                    sidedish = view.sidedish,
                    isMultipleByProduct = sidedish.getIsMultipleByProduct(),
                    checked = isMultipleByProduct ? false : currentTarget.checked,
                    previousTotalQty = sidedish.getSelectionQuantity(),
                    previousProductQty = sidedish.getSelectionQuantity(id_product),
                    max = sidedish.getMaximum(),
                    add = checked;
                //
                if(isMultipleByProduct){ // quantifier button
                    var newProductQty = parseInt(currentTarget.value);
                    add = newProductQty > previousProductQty;
                }
                if(!isMultipleByProduct && previousTotalQty>=max && checked){ // checkbox
                    // si on essaie d'ajouter et qu'on est au maximum
                    var shiftedSelection = sidedish.shiftSelection();
                    view.$('input[data-id_product="'+shiftedSelection.id+'"]').attr('checked',false);
                }
                sidedish.changeSelection(add, id_product+'');
                view.trigger('change');
                view.render();
            },
            clickQuantifier:function(e){
                var view = this,
                    sidedish = view.sidedish,
                    $button = $(e.currentTarget),
                    add = !$button.is('.less'),
                    id_product = $button.data('id_product')
                ;
                if(sidedish.getIsMultipleByProduct()){
                    sidedish.changeSelection(add, id_product+'');
                    view.trigger('change');
                    view.render();
                    e.preventDefault();
                }
            },
            render:function(){
                var view = this,
                    sidedish = view.sidedish,
                    isMultipleByProduct = sidedish.getIsMultipleByProduct(),
                    max = sidedish.getMaximum(),
                    totalQty = sidedish.getSelectionQuantity(),
                    selection;
                if(isMultipleByProduct){
                    selection = sidedish.getSelection();
                    sidedish.getCategoryProducts().each(function(product){
                        var id_product = product.id,
                            isStockout = product.isStockout(),
                            qty = sidedish.getSelectionQuantity(id_product),
                            canAdd = totalQty>=max && !isStockout,
                            canRemove = qty===0 && !isStockout;
                        view.$('.more[data-id_product='+id_product+'], .sidedish__el__label[data-id_product='+id_product+']').attr('disabled',canAdd)
                        view.$('.less[data-id_product='+id_product+']').attr('disabled',canRemove);
                        view.$('input[data-id_product='+id_product+']').val(qty).attr('disabled',canAdd);
                        view.$('.sidedish__el__qty--value[data-id_product='+id_product+']')
                            .attr('data-qty',qty)
                            .text(qty);
                    });
                }else{
                    sidedish.getCategoryProducts().each(function(product){
                        var id_product = product.id,
                            qty = sidedish.getSelectionQuantity(id_product);
                        view.$('input[data-id_product='+id_product+']').prop('checked',qty>0);
                    });
                }
            }
        })
})
;
